import React, { useState } from 'react';
import { PageHeader, ScrollReveal } from '../components/UI';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '', website: '', service: '', budget: '', message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };

  return (
    <div>
      <PageHeader 
        title="Let's Talk"
        subtitle="Ready to grow your business? Schedule a free strategy call and let's discuss how we can help you dominate your market."
        breadcrumb="Contact"
      />

      <section style={{ padding: '80px 24px', background: '#f8f9fa' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 60, alignItems: 'start' }}>
            {/* Contact Info */}
            <ScrollReveal>
              <div>
                <h2 style={{ fontSize: 28, fontWeight: 800, color: '#1a1a2e', marginBottom: 16 }}>Get In Touch</h2>
                <p style={{ color: '#666', fontSize: 16, lineHeight: 1.7, marginBottom: 32 }}>
                  Have questions? Want to discuss your project? We're here to help. Reach out anytime and we'll get back to you within a few hours.
                </p>

                <div style={{ marginBottom: 32 }}>
                  {[
                    { icon: '📧', label: 'Email', value: 'hello@crescitmarketing.com', href: 'mailto:hello@crescitmarketing.com' },
                    { icon: '📱', label: 'Phone', value: '+1 (555) 123-4567', href: 'tel:+15551234567' },
                    { icon: '🕐', label: 'Hours', value: 'Mon-Fri: 9AM - 6PM EST', href: null },
                    { icon: '⏰', label: 'Response Time', value: 'Within 2-4 hours', href: null },
                  ].map((item, i) => (
                    <div key={i} style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
                      <div style={{ width: 48, height: 48, background: 'white', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                        {item.icon}
                      </div>
                      <div>
                        <div style={{ color: '#888', fontSize: 13, marginBottom: 2 }}>{item.label}</div>
                        {item.href ? (
                          <a href={item.href} style={{ color: '#1a1a2e', fontWeight: 600, fontSize: 16 }}>{item.value}</a>
                        ) : (
                          <div style={{ color: '#1a1a2e', fontWeight: 600, fontSize: 16 }}>{item.value}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div style={{ background: 'linear-gradient(135deg, #1a1a2e, #16213e)', borderRadius: 20, padding: 28 }}>
                  <h3 style={{ color: 'white', fontSize: 18, fontWeight: 700, marginBottom: 12 }}>What to Expect</h3>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {[
                      '30-minute strategy call at your convenience',
                      'No pressure, no obligation',
                      'Custom recommendations for your business',
                      'Clear next steps if we\'re a fit'
                    ].map((item, i) => (
                      <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'rgba(255,255,255,0.8)', fontSize: 14, marginBottom: 10 }}>
                        <span style={{ color: '#ff6b35' }}>✓</span> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </ScrollReveal>

            {/* Contact Form */}
            <ScrollReveal delay={0.2}>
              <div style={{ background: 'white', borderRadius: 24, padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,0.1)' }}>
                {submitted ? (
                  <div style={{ textAlign: 'center', padding: 40 }}>
                    <div style={{ fontSize: 64, marginBottom: 20 }}>✅</div>
                    <h3 style={{ fontSize: 28, fontWeight: 800, color: '#1a1a2e', marginBottom: 12 }}>Thank You!</h3>
                    <p style={{ color: '#666', fontSize: 17, lineHeight: 1.7 }}>
                      We've received your message and will be in touch within 24 hours to schedule your free strategy call.
                    </p>
                  </div>
                ) : (
                  <>
                    <h2 style={{ fontSize: 24, fontWeight: 800, color: '#1a1a2e', marginBottom: 8 }}>Request Your Free Strategy Call</h2>
                    <p style={{ color: '#666', fontSize: 15, marginBottom: 28 }}>
                      Fill out the form below and we'll reach out within 24 hours.
                    </p>
                    <form onSubmit={handleSubmit}>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                        <div>
                          <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Name *</label>
                          <input type="text" name="name" required value={formData.name} onChange={handleChange}
                            style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15 }}
                            placeholder="John Smith"
                          />
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Email *</label>
                          <input type="email" name="email" required value={formData.email} onChange={handleChange}
                            style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15 }}
                            placeholder="john@company.com"
                          />
                        </div>
                      </div>

                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                        <div>
                          <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Phone</label>
                          <input type="tel" name="phone" value={formData.phone} onChange={handleChange}
                            style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15 }}
                            placeholder="(555) 123-4567"
                          />
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Company</label>
                          <input type="text" name="company" value={formData.company} onChange={handleChange}
                            style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15 }}
                            placeholder="Your Company"
                          />
                        </div>
                      </div>

                      <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Website</label>
                        <input type="url" name="website" value={formData.website} onChange={handleChange}
                          style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15 }}
                          placeholder="https://yourwebsite.com"
                        />
                      </div>

                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                        <div>
                          <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Service Interested In</label>
                          <select name="service" value={formData.service} onChange={handleChange}
                            style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15, background: 'white' }}>
                            <option value="">Select a service</option>
                            <option value="google-ads">Google Ads Management</option>
                            <option value="local-seo">Local SEO</option>
                            <option value="technical-seo">Technical SEO</option>
                            <option value="analytics">Analytics & Reporting</option>
                            <option value="full-service">Full Service (All)</option>
                            <option value="not-sure">Not Sure Yet</option>
                          </select>
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Monthly Budget</label>
                          <select name="budget" value={formData.budget} onChange={handleChange}
                            style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15, background: 'white' }}>
                            <option value="">Select budget range</option>
                            <option value="under-1500">Under $1,500/mo</option>
                            <option value="1500-3000">$1,500 - $3,000/mo</option>
                            <option value="3000-5000">$3,000 - $5,000/mo</option>
                            <option value="5000-plus">$5,000+/mo</option>
                            <option value="not-sure">Not sure yet</option>
                          </select>
                        </div>
                      </div>

                      <div style={{ marginBottom: 24 }}>
                        <label style={{ display: 'block', fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 6 }}>Tell Us About Your Business & Goals</label>
                        <textarea name="message" value={formData.message} onChange={handleChange} rows={4}
                          style={{ width: '100%', padding: 14, borderRadius: 10, border: '1px solid #ddd', fontSize: 15, resize: 'none' }}
                          placeholder="What are you looking to achieve? What challenges are you facing?"
                        />
                      </div>

                      <button type="submit" className="btn-primary" style={{ width: '100%', padding: 18, borderRadius: 50, fontSize: 17 }}>
                        Request My Free Strategy Call →
                      </button>

                      <p style={{ textAlign: 'center', color: '#888', fontSize: 13, marginTop: 16 }}>
                        By submitting, you agree to our privacy policy. We'll never spam you.
                      </p>
                    </form>
                  </>
                )}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Map or Additional Info */}
      <section style={{ padding: '80px 24px', background: 'white' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
          <ScrollReveal>
            <h2 style={{ fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: 800, color: '#1a1a2e', marginBottom: 16 }}>
              Serving Businesses Nationwide
            </h2>
            <p style={{ color: '#666', fontSize: 17, lineHeight: 1.7, marginBottom: 40, maxWidth: 600, margin: '0 auto 40px' }}>
              We work with local businesses across the United States, Canada, and Australia. Distance is never a barrier—our strategies work regardless of location.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 40, flexWrap: 'wrap' }}>
              {[
                { flag: '🇺🇸', country: 'United States', detail: 'All 50 states' },
                { flag: '🇨🇦', country: 'Canada', detail: 'All provinces' },
                { flag: '🇦🇺', country: 'Australia', detail: 'All territories' },
              ].map((loc, i) => (
                <div key={i} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 48, marginBottom: 8 }}>{loc.flag}</div>
                  <div style={{ fontWeight: 700, color: '#1a1a2e', fontSize: 18 }}>{loc.country}</div>
                  <div style={{ color: '#888', fontSize: 14 }}>{loc.detail}</div>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
};

export default Contact;
